import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectSheet } from '@/domain/termine/features/UpdateTermin/Desktop/components/CalendarSelectSheet';
import { CalendarSelectDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/CalendarSelectDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';

export function CalendarSelectFormField({ form }: UpdateTermineFormProps) {
  const { kalender } = useCalendarContext();

  return (
    <>
      {kalender.length > 1 && (
        <>
          <div className="block md:hidden">
            <CalendarSelectDrawer kalender={kalender} form={form} />
          </div>
          <div className="hidden md:block">
            <CalendarSelectSheet kalender={kalender} form={form} />
          </div>
        </>
      )}
    </>
  );
}
